(ns priorities.goals
  (:require
    [reagent.core :as r]
    [css.icons :as icon :refer [feeling-icon]]
    [css.core :refer [defstyled]]
    [css.form :as form]
    [css.vars :as vars]
    [css.typography :as typo]
    [main.common :as common]
    [util.core :refer [long-str to-local-time to-input-date now]]))

(defstyled goal-form-s :form
  {:grid-column "span 3"
   :padding "2rem"
   :min-width "600px"})

(defstyled goal-feeling-wrapper-s :div
  {:display "flex"
   :flex-direction "column"})

(defstyled goal-feeling-label-s :div
  {:font-size "1.1rem"
   :opacity ".9"
   :margin "0 0 .5rem"})

(defstyled selectable-feelings-s :ul
  {:display "flex"
   :align-items "center"})

(defstyled selectable-feeling-s :li
  {:margin-right ".5rem"
   :display "flex"
   :padding "5px"
   :cursor "pointer"
   :transition "all .25s ease-in"
   :opacity ".45"
   :&:hover {:opacity "1"}})

(defstyled custom-buttons-s :div
  {:display "flex"
   :align-items "center"})

(defstyled divider-s :span
  {:border-right "1px solid #eee"
   :height "12px"
   :margin "0 .25rem"})

(def *goals-to-show* 3)

(defn- selectable-feelings [feeling on-change]
  (into [selectable-feelings-s]
        (map (fn [f]
               [selectable-feeling-s {:style {:opacity (when (= feeling f) "1")}
                                      :on-click #(on-change f)}
                [feeling-icon f]])
             ["VERY_DISSATISFIED"
              "DISSATISFIED"
              "NEUTRAL"
              "SATISFIED"
              "VERY_SATISFIED"])))

(defn- add-goal [{:keys [add cancel]}]
  (let [goal (r/atom nil)
        target-date (r/atom nil)
        feeling (r/atom "NEUTRAL")]
    (fn []
      [goal-form-s {:on-submit (fn [e]
                                 (.preventDefault e)
                                 (add {:target-date (.-value @target-date)
                                       :title (.-value @goal)
                                       :feeling @feeling}))}
       [typo/h2 {:margin "0 0 2rem"} "Add a goal for managing my budget"]
       [form/input-row-s
        [form/input-label-s "Goal description"]
        [form/input {:ref #(reset! goal %)
                     :label? true
                     :type "text"
                     :max-length 50
                     :placeholder "Goal Description"
                     :required true
                     :max-width "100%"}]]
       [form/input-row-s
        [form/input-label-s "Goal target date"]
        [form/future-date {:ref #(reset! target-date %)
                           :label? true}]]
       [goal-feeling-wrapper-s
        [goal-feeling-label-s "How I feel about this goal"]
        [selectable-feelings @feeling #(reset! feeling %)]]
       [form/button-row-s {:justify "flex-start"
                           :margin "3rem 0 0"}
        [form/secondary-button-s {:on-click cancel
                                  :type "button"} "Cancel"]
        [form/button {:type "submit"} "Save"]]])))


(defstyled empty-goals-s :p
  {:margin "0 0 1.5rem 1rem"
   :color "#666"})

(defstyled goals-s :ol
  {:margin "0 0 0 2rem"})

(defstyled goal-s :li
  {:padding "0 0 1.5rem"
   :color "#666"
   :border-bottom "1px solid #afafaf"
   :&:last-child {:border-bottom "none"}})

(defstyled goal-info-s :div
  {:flex-direction "row"
   :display "flex"
   :align-items "center"})

(defstyled goal-controls-s :div
  {})

(defstyled goal-date-s :div
  {:border-right (str "2px solid " vars/border-light)
   :margin-right "1rem"
   :padding-right "1rem"
   :display "flex"
   :align-items "center"
   :flex-direction "row"})

(defstyled cal-icon-s :div
  {:margin-right "1rem"})

(defstyled goal-feeling-s :div
  {})

(defstyled more-goals-s :a
  {:cursor "pointer"
   :font-size "13px"
   :margin "1.75rem 0 2rem"
   :display "inline-block"
   :text-decoration "underline"
   :color "#666"})

(defstyled chevron-icon-right-s :div
  {:margin-left ".5rem"})

(defn- goals [goals]
  (let [count-to-show (r/atom *goals-to-show*)]
    (fn [goals delete-goal]
      (if (empty? goals)
        [empty-goals-s "There are no goals for this priority."]
        [goals-s
         (take @count-to-show
               (for [goal goals]
                 ^{:key (:id goal)}
                 [goal-s
                  [common/data-row {:label "Goal:"
                                    :value (:title goal)}]
                  [goal-info-s
                   (when (:target-date goal)
                     [goal-date-s
                      [cal-icon-s [icon/calendar]]
                      (to-local-time (:target-date goal))])
                   [goal-feeling-s (feeling-icon (:feeling goal))]]
                  (when delete-goal
                    [goal-controls-s
                     [form/naked-button-s {:type "button"
                                           :on-click #(delete-goal goal)
                                           :margin "1rem 0 0"}
                      "Delete"]])]))
         (if (> (count goals) @count-to-show)
           [more-goals-s {:on-click #(reset! count-to-show (count goals))}
            "See all " (count goals) " goals"
            [chevron-icon-right-s {:class "fas fa-chevron-right"}]])]))))
